import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/pilots`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/pilots/${itemId}`, payload);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/pilots/sorts`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/pilots`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/pilots/${itemId}`);
  },
};
